import moment from 'moment';
import { getClientRiskLevels } from '../../HttpRequests/clientRiskLevels';
import { loadClientRiskLevels } from '../State/clientRiskLevels';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getClientRiskLevels();

    dispatch(loadClientRiskLevels(response.data.data));

  } catch (error) {
    
    throw error;

  }
}